import toast from "react-hot-toast";
import { log, supabase } from ".";
import { generaComision } from "../constants/estadosEdificio";
import { EDIFICIOS_EXCLUIDOS } from "../constants/permisos";

// Predicado ÚNICO de "operativo comercial" (regla 10.1): genera comisión (OPERATIVO) + vivo
// (eliminada=false) + no está en el parche EDIFICIOS_EXCLUIDOS (cartelería pura / excluidos a mano).
// Es la definición canónica de "cantidad de edificios operativos" para inventario/badges/landings.
// Comparación por ID (regla 10.7). Lo consumen el fetch de abajo Y los conteos que ya tienen el
// array de edificios cargado (EdificiosTable badge, InventarioSimple KPI) — sin refetch ni reimplementar.
export const esOperativoComercial = (edificio) =>
  generaComision(edificio.estado) && !edificio.eliminada && !EDIFICIOS_EXCLUIDOS.includes(edificio.id);

export const getEdificiosOperativos = async ({ pais }) => {
  try {
    // Asumiendo que supabase.select es la forma correcta de hacer la consulta en tu configuración
    const data = await supabase.select("edificios", {
      filters: {
        pais,
      },
      orderBy: "pantallas",
      ascending: false,
    });

    // Filtrar por estado que genera comisión (OPERATIVO) — fuente única estadosEdificio.
    // Solo vivos (eliminada=false). Excluir EDIFICIOS_EXCLUIDOS (parche, ver Bloque E).
    const filteredData = data.filter(esOperativoComercial);

    if (filteredData.length === 0) {
      toast.error("No hay edificios cargados en la base de datos");
      throw new Error("No data found");
    }

    return filteredData;
  } catch (error) {
    log.error("getEdificiosOperativos", error);
    throw error;
  }
};
